import { Box } from "@mui/material";
import { keyframes } from "@emotion/react";

import archFrame from "../../../assets/Images/Temples/arch-frame.svg";
import archPattern from "../../../assets/Images/Temples/arch-pattern.svg";
import archPatternMask from "../../../assets/Images/Temples/arch-pattern-mask.svg";
import archOutline from "../../../assets/Images/Temples/arch-outline.svg";
import dot1 from "../../../assets/Images/Temples/arch-dot-1.svg";
import dot2 from "../../../assets/Images/Temples/arch-dot-2.svg";
import dot3 from "../../../assets/Images/Temples/arch-dot-3.svg";
import dot4 from "../../../assets/Images/Temples/arch-dot-4.svg";
import dot5 from "../../../assets/Images/Temples/arch-dot-5.svg";
import dot6 from "../../../assets/Images/Temples/arch-dot-6.svg";
import dot7 from "../../../assets/Images/Temples/arch-dot-7.svg";
import dot8 from "../../../assets/Images/Temples/arch-dot-8.svg";
import dot9 from "../../../assets/Images/Temples/arch-dot-9.svg";
import dot10 from "../../../assets/Images/Temples/arch-dot-10.svg";
import dot11 from "../../../assets/Images/Temples/arch-dot-11.svg";
import lotus from "../../../assets/Images/Temples/arch-lotus.svg";
import ring from "../../../assets/Images/Temples/rosette-ring.svg";
import center from "../../../assets/Images/Temples/rosette-center.svg";
import l0 from "../../../assets/Images/Temples/rosette-l-0.svg";
import l45 from "../../../assets/Images/Temples/rosette-l-45.svg";
import l90 from "../../../assets/Images/Temples/rosette-l-90.svg";
import l135 from "../../../assets/Images/Temples/rosette-l-135.svg";
import l180 from "../../../assets/Images/Temples/rosette-l-180.svg";
import l225 from "../../../assets/Images/Temples/rosette-l-225.svg";
import l270 from "../../../assets/Images/Temples/rosette-l-270.svg";
import l315 from "../../../assets/Images/Temples/rosette-l-315.svg";
import r0 from "../../../assets/Images/Temples/rosette-r-0.svg";
import r45 from "../../../assets/Images/Temples/rosette-r-45.svg";
import r90 from "../../../assets/Images/Temples/rosette-r-90.svg";
import r135 from "../../../assets/Images/Temples/rosette-r-135.svg";
import r180 from "../../../assets/Images/Temples/rosette-r-180.svg";
import r225 from "../../../assets/Images/Temples/rosette-r-225.svg";
import r270 from "../../../assets/Images/Temples/rosette-r-270.svg";
import r315 from "../../../assets/Images/Temples/rosette-r-315.svg";
import pillarLine from "../../../assets/Images/Temples/pillar-line.svg";
import pillarDiamond from "../../../assets/Images/Temples/pillar-diamond.svg";
import bell0 from "../../../assets/Images/Temples/bell-0.svg";
import bell1 from "../../../assets/Images/Temples/bell-1.svg";
import bell2 from "../../../assets/Images/Temples/bell-2.svg";
import bell3 from "../../../assets/Images/Temples/bell-3.svg";
import bell4 from "../../../assets/Images/Temples/bell-4.svg";
import bell5 from "../../../assets/Images/Temples/bell-5.svg";
import bell6 from "../../../assets/Images/Temples/bell-6.svg";
import bell7 from "../../../assets/Images/Temples/bell-7.svg";
import bell8 from "../../../assets/Images/Temples/bell-8.svg";

// The arch is drawn on a 1410 × 760 frame and positions below are in frame
// pixels. `--u` (set on the hero) is one frame pixel: below 1410px wide it
// shrinks so the whole hero scales evenly; wider than that it stays 1px, the
// height stays 760px and the arch stretches sideways. Ornaments keep their
// size and are placed by percentage across the width, so nothing distorts.
export const FRAME_WIDTH = 1410;
export const FRAME_HEIGHT = 760;
export const UNIT = `min(1px, calc(100cqw / ${FRAME_WIDTH}))`;
export const u = (px) => `calc(var(--u) * ${px})`;
export const pct = (x) => `${((x / FRAME_WIDTH) * 100).toFixed(4)}%`;
// Left edge of an element whose centre sits at frame x `cx`. Pieces of one
// ornament share an `anchor` so they move together instead of spreading apart.
export const leftAt = (cx, w, anchor = cx) => `calc(${pct(anchor)} + ${u(cx - anchor - w / 2)})`;

// [src, x, y, width, height, rotation, anchor]
const DECOR = [
  [dot1, 29.47, 218.2, 5.08, 5.17],
  [dot2, 66.83, 173.58, 5.22, 5.24],
  [dot3, 163.84, 138.93, 5.22, 5.17],
  [dot4, 298.36, 112.48, 5.22, 5.24],
  [dot4, 447.96, 92.87, 5.08, 5.24],
  [dot5, 589.94, 78.58, 5.22, 5.24],
  [dot6, 702.46, 68.17, 5.08, 5.24],
  [dot7, 814.84, 78.58, 5.22, 5.24],
  [dot8, 956.97, 92.87, 5.08, 5.24],
  [dot8, 1106.43, 112.48, 5.22, 5.24],
  [dot9, 1240.94, 138.93, 5.22, 5.17],
  [dot10, 1337.95, 173.58, 5.22, 5.24],
  [dot11, 1375.45, 218.2, 5.08, 5.17],
  [lotus, 691.18, 33.72, 27.7, 24.19],
  [ring, 88.42, 98.48, 23.1, 23.1, 0, 100],
  [ring, 1298.48, 98.48, 23.1, 23.1, 0, 1310],
  [l0, 97.96, 100.32, 4.1, 7.3, 0, 100],
  [l45, 102.12, 102.07, 4.1, 7.3, 45, 100],
  [l90, 103.88, 106.29, 4.1, 7.3, 90, 100],
  [l135, 102.12, 110.58, 4.1, 7.3, 135, 100],
  [l180, 97.96, 112.29, 4.1, 7.3, 180, 100],
  [l225, 93.66, 110.58, 4.1, 7.3, -135, 100],
  [l270, 91.9, 106.29, 4.1, 7.3, -90, 100],
  [l315, 93.66, 102.07, 4.1, 7.3, -45, 100],
  [r0, 1307.88, 100.32, 4.1, 7.3, 0, 1310],
  [r45, 1312.18, 102.07, 4.1, 7.3, 45, 1310],
  [r90, 1313.95, 106.29, 4.1, 7.3, 90, 1310],
  [r135, 1312.18, 110.58, 4.1, 7.3, 135, 1310],
  [r180, 1307.88, 112.29, 4.1, 7.3, 180, 1310],
  [r225, 1303.72, 110.58, 4.1, 7.3, -135, 1310],
  [r270, 1301.96, 106.29, 4.1, 7.3, -90, 1310],
  [r315, 1303.72, 102.07, 4.1, 7.3, -45, 1310],
  [center, 98.0, 108.0, 4, 4, 0, 100],
  [center, 1308.06, 108.0, 4, 4, 0, 1310],
  [pillarLine, 10.4, 260.83, 11.2, 459.19],
  [pillarDiamond, 11.0, 484.42, 10, 12],
  [pillarLine, 1388.39, 260.83, 11.2, 459.19],
  [pillarDiamond, 1388.99, 484.42, 10, 12],
];

// x/y is where each bell's chain hangs from the arch; angle is its resting tilt.
const BELLS = [
  { src: bell0, x: 167.0, y: 141.4, h: 44.8, angle: -8 },
  { src: bell1, x: 301.5, y: 115.0, h: 60.2, angle: -5 },
  { src: bell2, x: 451.0, y: 95.4, h: 50.4, angle: -6.5 },
  { src: bell3, x: 593.1, y: 81.1, h: 67.2, angle: -8 },
  { src: bell4, x: 705.5, y: 70.8, h: 47.6, angle: -5 },
  { src: bell5, x: 817.8, y: 81.2, h: 57.4, angle: -6.5 },
  { src: bell6, x: 960.0, y: 95.4, h: 53.2, angle: -8 },
  { src: bell7, x: 1109.5, y: 115.0, h: 64.4, angle: -5 },
  { src: bell8, x: 1244.0, y: 141.4, h: 46.2, angle: -6.5 },
];
const BELL_WIDTH = 23.8;

// Each bell rocks from its resting tilt to the mirrored tilt and back.
export const swing = keyframes`
  0%, 100% { transform: rotate(var(--bell-rest)); }
  50% { transform: rotate(calc(var(--bell-rest) * -1)); }
`;

// Ornament: fixed size, centred on its frame x.
const layerSx = (x, y, w, h, rotate, anchor) => ({
  position: "absolute",
  left: leftAt(x + w / 2, w, anchor || undefined),
  top: u(y),
  width: u(w),
  height: u(h),
  transform: rotate ? `rotate(${rotate}deg)` : undefined,
  pointerEvents: "none",
});

// Arch shapes: stretch across the width, fixed height.
const stretchSx = (x, y, w, h) => ({
  position: "absolute",
  left: pct(x),
  top: u(y),
  width: pct(w),
  height: u(h),
  pointerEvents: "none",
});

const TempleArch = () => (
  <Box aria-hidden="true" sx={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
    <Box component="img" src={archFrame} alt="" sx={stretchSx(0, 0, FRAME_WIDTH, FRAME_HEIGHT)} />

    {/* Faint pattern inside the arch, clipped to the arch shape */}
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        maskImage: `url("${archPatternMask}")`,
        maskSize: "100% 100%",
        maskRepeat: "no-repeat",
        WebkitMaskImage: `url("${archPatternMask}")`,
        WebkitMaskSize: "100% 100%",
        WebkitMaskRepeat: "no-repeat",
      }}
    >
      <Box component="img" src={archPattern} alt="" sx={stretchSx(21.3, 30.84, 1367.33, 736.12)} />
    </Box>

    <Box component="img" src={archOutline} alt="" sx={stretchSx(27.34, 36.84, 1355.33, 724.17)} />

    {DECOR.map(([src, x, y, w, h, rotate, anchor], index) => (
      <Box key={index} component="img" src={src} alt="" sx={layerSx(x, y, w, h, rotate, anchor)} />
    ))}

    {BELLS.map((bell, index) => (
      <Box
        key={bell.src}
        component="img"
        src={bell.src}
        alt=""
        sx={{
          ...layerSx(bell.x - BELL_WIDTH / 2, bell.y, BELL_WIDTH, bell.h),
          "--bell-rest": `${bell.angle}deg`,
          transform: "rotate(var(--bell-rest))",
          transformOrigin: "50% 0",
          animation: `${swing} ${2.4 + (index % 3) * 0.3}s ease-in-out ${-index * 0.35}s infinite`,
          "@media (prefers-reduced-motion: reduce)": { animation: "none" },
        }}
      />
    ))}
  </Box>
);

export default TempleArch;
